// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import { registerMicroApps, start } from 'qiankun';
import router from "./router";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 引入 Element UI 的样式
Vue.use(ElementUI);
import Vant from "vant";
import { Toast } from "vant";
import "@/assets/iconfont.ttf"; // 引入字体文件
import "@/assets/iconfont.css";
import axios from "axios";
import store from './store';
import echarts from "@/utils/echarts.js";
import "@/style/common.less";
import "@/style/process.css";
// import * as echarts from 'echarts';
 import "font-awesome/css/font-awesome.min.css"
Vue.prototype.$echarts = echarts;
import VueFormulate from '@braid/vue-formulate';
Vue.use(VueFormulate);

import Vuex from "vuex"
Vue.use(Vuex)
Vue.prototype.$http = axios;
console.log(axios);
import Axios from "axios";
Axios.defaults.baseURL = "/api";
Vue.prototype.$http = Axios;
Vue.prototype.$toast = Toast;
Axios.defaults.headers.post["Content-Type"] = "application/json";
// require("./utils/adapter")(document, window);
import VConsole from "vconsole";
import moment from "moment";
moment.locale("zh-cn");
Vue.prototype.$moment = moment;
import wx from "weixin-js-sdk";
Vue.prototype.$wx = wx;
import "vant/lib/index.css";
import { Lazyload } from "vant";
Vue.use(Vant);
import { RadioGroup, Radio } from "vant";
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.config.productionTip = false;
Vue.use(Lazyload, {
    lazyComponent: true,
});
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
    ak: "zc9a3Tmm15WzGYqh7mBWwb9vE20oCBU9",
});
import VueHtml5Plus from 'vue-html5plus';
// Vue.use(VueHtml5Plus)
Vue.prototype.$VueHtml5Plus = VueHtml5Plus;
import plus from '@h5plus/core'
// Vue.use(plus)
Vue.prototype.$plus = plus;
Vue.prototype.resetSetItem = function(key, newVal) {
    //监听的session字段
    if (key === 'isStaticTabBar') {
        // 创建一个StorageEvent事件
        const storage = {
            setItem: function(k, val) {
                sessionStorage.setItem(k, val);
                // 初始化创建的事件
                const newStorageEvent = new CustomEvent('setItem', {
                    bubbles: false,
                    cancelable: false,
                    detail: {
                        key: k,
                        oldValue: null,
                        newValue: val,
                        url: null
                    }
                });
                // 派发对象
                window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
}
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

import { FileIcon } from 'vant-green';
Vue.use(FileIcon);

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.configure({
    showSpinner: false, // 可选，关闭默认的 spinner
});
import TaskTheme from '@/components/TaskTheme.vue';
Vue.component('TaskTheme', TaskTheme);


// 导入需要传递给子应用的API接口
import { yJWechatAwardSummaryPageList, yJWechatAwardSummaryDetail } from '@/api/ompanyHonorsInface/yJWechatAwardSummaryPageList';
import request from '@/utils/request';


const loader=(loading)=> {
  console.log('子应用加载中...',loading);
}

//注册子应用
registerMicroApps([
    {
        name: "app-vue1",
        entry: "//localhost:9001",// 子应用加载的入口
        container: "#subapp-container",//渲染到哪里
        activeRule: "/subapp/app-vue1",//当路由匹配到/subapp/app-vue1时，加载子应用
        loader,
        props: {
            // 传递主应用的API调用能力给子应用
            mainAppAPI: {
                // 传递具体的API接口
                yJWechatAwardSummaryPageList,
                yJWechatAwardSummaryDetail,
                // 传递完整的request实例，子应用可以直接使用
                request: request, // 这个包含了所有拦截器和配置
                // 传递原始的axios实例（作为备用）
                axios: request,
                // 传递主应用的基础配置
                baseURL: '/api',
                // 传递token获取方法
                getToken: () => localStorage.getItem('setToken'),
                getAccessToken: () => localStorage.getItem('setAccessToken'),
                // 传递Toast方法保证一致性
                Toast: Toast
            },
            // 传递其他共享数据
            globalData: {
                userInfo: () => JSON.parse(localStorage.getItem('userInfo') || '{}'),
                version: '1.0.0'
            }
        }
    },
   
]);

// 启动微前端
start({
    sandbox: {
        strictStyleIsolation: true,  // 开启严格样式隔离
        experimentalStyleIsolation: true  // 开启实验性样式隔离
    }
});

// 定义全局变量
Vue.prototype.$workFlow_TaskTheme = '';

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "";
    if (to.query.workFlow_TaskTheme) {
        Vue.prototype.$workFlow_TaskTheme = to.query.workFlow_TaskTheme;
        console.log('workFlow_TaskTheme 参数存在:', to.query.workFlow_TaskTheme);
    } else {
        console.log('workFlow_TaskTheme 参数不存在');
    }
    next();
});
/* eslint-disable no-new */
new Vue({
    store,
    router,
    render: (h) => h(App),
}).$mount("#app");